import * as React from 'react'

const SvgEyedropperIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 16.875h1.875v1.875H1.25v-1.875zM18.569 4.556l-3.125-3.125a.625.625 0 00-.882 0L12.5 3.494l-.806-.813-.888.888.813.806-6.438 6.431A.625.625 0 005 11.25v.994L3.306 13.93a.625.625 0 000 .882l1.875 1.874a.625.625 0 00.881 0L7.756 15h.994a.625.625 0 00.444-.181l6.431-6.438.806.813.888-.888-.813-.806 2.063-2.056a.625.625 0 000-.881v-.007zM8.494 13.75h-1.25l-1.619 1.619-.994-.994 1.619-1.619v-1.25l6.25-6.25L14.744 7.5l-6.25 6.25zm7.131-7.131l-2.244-2.244L15 2.756 17.244 5l-1.619 1.619z"
      fill="#163250"
    />
  </svg>
)

export default SvgEyedropperIcon
